import React, { useState, useEffect } from "react";
import { Card, Spinner } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import IconButton from 'components/common/IconButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import UserPermissionTable from "components/partials/permissions/user-permission/UserPermissionTable";
import UserPermissionModal from "./UserPermissionModal";
import UserDropdown from "components/dropdowns/UserDropdown";
import { toast } from 'react-toastify';
import BasicTemplate from 'components/Toast/BasicTemplate';
import { search, getById } from "services/permissions/userPermissionServices";
import { BaseTableRQ } from "components/pages/stock-location/models/BaseTable"

export default function UserPermissionList() {
    const [userPermissions, setUserPermissions] = useState([]);
    const [total, setTotal] = useState(0);
    const [paging, setPaging] = useState(new BaseTableRQ(1, 100));
    const [selectedUser, setSelectedUser] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [isLoadingRow, setIsLoadingRow] = useState(false);

    useEffect(() => {
        loadUserPermissions(paging);
    }, [])

    const loadUserPermissions = (pagingRq, userId = selectedUser) => {
        setIsSearching(true);
        search(pagingRq, userId).then(res => {
            if (res) {
                setUserPermissions(res.items);
                setTotal(res.total);
            }
        })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                setIsSearching(false);
            });

        setPaging(pagingRq);
    }

    const handleUserChange = (option) => {
        const userId = option?.value ?? null;
        setSelectedUser(userId);
        paging.pageNum = 1;
        loadUserPermissions(paging, userId);
    }

    const gotoPage = (index) => {
        index += 1;
        if (index <= 0) return;
        paging.pageNum = index;
        loadUserPermissions(paging);
    }

    const nextPage = () => {
        const page = paging.pageNum + 1;
        if (page > Math.ceil(total / paging.pageSize)) return;
        paging.pageNum = page;
        loadUserPermissions(paging);
    }

    const previousPage = () => {
        const page = paging.pageNum - 1;
        if (page <= 0) return;
        paging.pageNum = page;
        loadUserPermissions(paging);
    }

    const handleOpenNew = () => {
        setDataModal(null);
        setIsModal(true);
    }

    const handleClickRow = (e, row) => {
        if (!row?.original?.id) return;
        setIsLoadingRow(true);
        getById(row.original.id)
            .then(result => {
                if (result.success) {
                    setDataModal(result.data);
                } else {
                    toast.error(
                        <BasicTemplate
                            success={false}
                            text={result.message ?? 'Unable to load User Permission details.'}
                        />
                    );
                    setDataModal(row.original);
                }
                setIsModal(true);
            })
            .finally(() => {
                setIsLoadingRow(false);
            });
    }

    const handleCloseModal = () => {
        setIsModal(false);
        setDataModal(null);
    }

    const handleSubmitModal = () => {
        handleCloseModal();
        loadUserPermissions(paging);
    }

    return (
        <>
            <PageHeader
                title="User Permission List"
                description={`Manage and view all available User Permission from this page.`}
                className="mb-3"
            ></PageHeader>
            <Card>
                <FalconCardHeader
                    title="User Permission"
                    light
                    titleTag="h6"
                    endEl={
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ minWidth: '220px' }}>
                                <UserDropdown
                                    isMulti={false}
                                    showLogin
                                    isClearable
                                    selectedOptions={selectedUser}
                                    handleChange={handleUserChange}
                                />
                            </div>
                            {isSearching && (
                                <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                            )}
                            {isLoadingRow && (
                                <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                            )}
                            <IconButton
                                variant="falcon-default"
                                size="sm"
                                icon="plus"
                                transform="shrink-3"
                                onClick={handleOpenNew}
                            >
                                <span className="d-none d-sm-inline-block ms-1">New</span>
                            </IconButton>
                        </div>
                    }
                />
                <Card.Body style={{ padding: '10px' }}>
                    <UserPermissionTable
                        data={userPermissions}
                        paging={paging}
                        total={total}
                        nextPage={nextPage}
                        previousPage={previousPage}
                        gotoPage={gotoPage}
                        handleClickRow={handleClickRow}
                    />
                </Card.Body>
            </Card>
            <UserPermissionModal
                isShow={isModal}
                handleClose={handleCloseModal}
                data={dataModal}
                handleSubmit={handleSubmitModal}
            />
        </>)
}